
import ContextMenu from '@/components/Folders/Menus/ContextMenu'
import ContextMenuItem from '@/components/Folders/Menus/ContextMenuItem'
export default {
    name: 'BulkContextMenu',
    components: { ContextMenuItem, ContextMenu },
    methods: {
        open (evt) {
            this.$refs.contextMenu.open(evt)
        },
        close () {
            this.$refs.contextMenu.close()
        },
        emit (name, file) {
            this.$emit(name, file)
        }
    }
}
